<template>
  <CardBase :headerBorder="false" :contentPadding="'p-6 pt-0'">
    <template #header>{{ $route.meta.title }}: {{ $route.params.search }}</template>
    <template #content>
      <div class="my-4"></div>
      <vue-good-table
        mode="remote"
        theme="polar-bear"
        :rows="tableData.rows"
        :columns="tableData.columns"
        :total-rows="tableData.totalRows"
        :is-loading.sync="tableData.isLoading"
        :pagination-options="{
          enabled: false,
        }"
        :sort-options="{
          multipleColumns: false,
        }"
        styleClass="vgt-table striped bordered mt-2 lg:mt-0"
        @on-page-change="onPageChange"
        @on-per-page-change="onPerPageChange"
      >
        <template slot="table-row" slot-scope="props">
          <span v-if="props.column.field == 'deposit'">
            <router-link
              :to="{ name: 'DepositCreate', params: {accountId: props.row.uuid }}"
              class="button button--primary text-center poppins"
              v-if="userCan('create.deposit')"
            >
              <font-awesome-icon :icon="['fas', 'coins']" class="mr-1" />Deposit
            </router-link>
          </span>
          <span v-else-if="props.column.field == 'withdraw'">
            <router-link
              :to="{ name: 'WithdrawCreate', params: {accountId: props.row.uuid }}"
              class="button button--primary text-center poppins mx-2"
              v-if="userCan('create.withdraw')"
            >
              <font-awesome-icon
                :icon="['fas', 'piggy-bank']"
                class="mr-1"
              />Withdraw
            </router-link>
          </span>
          <span v-else-if="props.column.field == 'transfer'">
            <router-link
              :to="{ name: 'TransferCreate', params: {accountId: props.row.uuid }}"
              class="button button--primary text-center poppins"
              v-if="userCan('create.transfer')"
            >
              <font-awesome-icon
                :icon="['fas', 'exchange-alt']"
                class="mr-1"
              />Transfer
            </router-link>
          </span>
        </template>
      </vue-good-table>
    </template>
  </CardBase>
</template>

<script>
import { showListMixin } from "@/mixins/showListMixin";
import { getListAssetMixin } from "@/mixins/getListAssetMixin";

export default {
  mixins: [showListMixin, getListAssetMixin],
  data() {
    return {
      tableData: {
        columns: [
          {
            label: "Member Name",
            field: "member.name",
            sortable: false,
          },
          {
            label: "Panel ID / Username",
            field: "tooltip",
            sortable: false,
          },
          {
            label: "",
            field: "deposit",
            sortable: false,
            width: "150px",
          },
          {
            label: "",
            field: "withdraw",
            sortable: false,
            width: "150px",
          },
          {
            label: "",
            field: "transfer",
            sortable: false,
            width: "150px",
          },
        ],
      },
    };
  },
  methods: {
    loadTableData() {
      this.debounce(() => {
        this.tableData.isLoading = true;
        this.$http
          .get(
            process.env.VUE_APP_API_URL +
              `/member-account?search=${this.$route.params.search}`
          )
          .then((res) => {
            this.tableData.rows = res.data.data;
            this.tableData.totalRows = res.data.total;
          });
      }, 500);
    },
  },
};
</script>
